import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { FolderOpen, Plus, Pencil, Trash2, X, Save } from 'lucide-react';

const CategoryManager = () => {
  const { api } = useAuth();
  const [cats, setCats] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', order: 0 });

  const load = () => api.get('/admin/categories').then(r => setCats(r.data)).catch(console.error);
  useEffect(() => { load(); }, []);

  const resetForm = () => { setForm({ name: '', order: 0 }); setEditing(null); setShowForm(false); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) { await api.put(`/admin/categories/${editing}`, form); }
      else { await api.post('/admin/categories', form); }
      resetForm(); load();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const handleEdit = (c) => { setForm({ name: c.name, order: c.order || 0 }); setEditing(c.id); setShowForm(true); };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this category?')) return;
    await api.delete(`/admin/categories/${id}`); load();
  };

  const flags = {
    'Indonesia': '🇮🇩', 'Japan': '🇯🇵', 'Korea': '🇰🇷', 'Thailand': '🇹🇭',
    'China': '🇨🇳', 'Vietnam': '🇻🇳', 'Philippines': '🇵🇭', 'Malaysia': '🇲🇾',
    'India': '🇮🇳', 'Western': '🌍'
  };

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2 className="section-title"><FolderOpen size={20} /> Categories ({cats.length})</h2>
        <button className="btn-primary" onClick={() => { resetForm(); setShowForm(true); }}><Plus size={16} /> Add Category</button>
      </div>

      {showForm && (
        <div className="admin-card" style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <h3 className="card-subtitle" style={{ margin: 0 }}>{editing ? 'Edit Category' : 'Add Category'}</h3>
            <button className="btn-sm btn-delete" onClick={resetForm}><X size={14} /></button>
          </div>
          <form onSubmit={handleSave}>
            <div className="two-col">
              <div>
                <label className="form-label">Category Name</label>
                <input className="form-input" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder="e.g. Indonesia" />
              </div>
              <div>
                <label className="form-label">Sort Order</label>
                <input className="form-input" type="number" value={form.order} onChange={e => setForm({...form, order: parseInt(e.target.value) || 0})} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <button type="submit" className="btn-primary" style={{ marginTop: 0 }}><Save size={16} /> {editing ? 'Update' : 'Save'}</button>
              <button type="button" className="btn-secondary" style={{ marginTop: 0 }} onClick={resetForm}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div className="admin-card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="admin-table">
          <thead>
            <tr><th>Flag</th><th>Name</th><th>Videos</th><th>Order</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {cats.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30, color: '#555' }}>No categories yet</td></tr>
            ) : cats.map(c => (
              <tr key={c.id}>
                <td style={{ fontSize: 24 }}>{flags[c.name] || '📁'}</td>
                <td style={{ fontWeight: 700, color: '#ddd', fontSize: 14 }}>{c.name}</td>
                <td><span className="badge badge-info">{c.count || 0} videos</span></td>
                <td style={{ color: '#555' }}>{c.order || 0}</td>
                <td>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button className="btn-sm btn-edit" onClick={() => handleEdit(c)}><Pencil size={12} /></button>
                    <button className="btn-sm btn-delete" onClick={() => handleDelete(c.id)}><Trash2 size={12} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CategoryManager;
